import ApiClient from './ApiClient'
import { appendIfPresent } from '../../utils/urlParams'

const ISSUES_URL = '/issues.json'
const PREFERENCES_URL = '/issues/preferences.json'
const EXPORT_URL = '/issues/export'

// Snake_case keys for the organization_alerts_preferences JSONB payload exchanged with Rails.
const PRIMARY_COLUMNS_KEY = 'primary_columns'
const QUESTION_IDS_KEY = 'question_ids'
const VARIABLE_IDS_KEY = 'variable_ids'

// The org endpoint keys collects by id and steps by name, both as arrays.
const buildParams = ({
  page, items, search, collectIds = [], steps = [], content = [], sort, direction, columns, variables,
  startDate, endDate, selectedIds
}) => {
  const params = new URLSearchParams()
  appendIfPresent(params, 'page', page)
  appendIfPresent(params, 'limit', items)
  appendIfPresent(params, 'q', search)
  appendIfPresent(params, 'sort', sort)
  appendIfPresent(params, 'direction', direction)
  appendIfPresent(params, 'start_date', startDate)
  appendIfPresent(params, 'end_date', endDate)
  collectIds.forEach(id => params.append('collect_ids[]', String(id)))
  steps.forEach(step => params.append('steps[]', String(step)))
  content.forEach(token => params.append('issue_content[]', String(token)))
  /*
   * Narrow extra_values server-side. `none` (sentinel) tells the API to skip
   * serializing all displayed_question_ids when no extra column is shown.
   */
  params.set('columns', columns && columns.length > 0 ? columns.join(',') : 'none')
  params.set('variables', variables && variables.length > 0 ? variables.join(',') : 'none')
  // Scope the export to the checked rows; empty selection falls back to the filtered set.
  if (selectedIds)
    selectedIds.forEach(id => params.append('issue_ids[]', String(id)))
  return params
}

class OrganizationIssuesService {
  static getIssues(params = {}) {
    return ApiClient.get(`${ISSUES_URL}?${buildParams(params).toString()}`)
  }

  // Org has no single collect, so the collectId that useLazyList passes is ignored here.
  static getQuestions() {
    return ApiClient.get('/issues/questions.json')
  }

  static getVariables() {
    return ApiClient.get('/issues/variables.json')
  }

  static savePreferences(preferences) {
    const payload = {}
    payload[PRIMARY_COLUMNS_KEY] = preferences.primaryColumns
    payload[QUESTION_IDS_KEY] = preferences.questionIds
    payload[VARIABLE_IDS_KEY] = preferences.variableIds
    return ApiClient.post(PREFERENCES_URL, { preferences: payload })
  }

  static exportUrl(params = {}, format = 'xlsx') {
    const query = buildParams(params)
    query.set('export_format', format)
    return `${EXPORT_URL}?${query.toString()}`
  }
}

export default OrganizationIssuesService
